import * as angular from "angular";
import {IController} from "angular";

export class selfPickupStatusButtonCtrl implements IController {

  status: any;
  isOutline: boolean = true;
  onChange: Function;

  private options: any;

  /* @ngInject */
  constructor(private selfPickupsConstants, public $mdMenu) {
  }

  $onInit() {
    this.options = this.selfPickupsConstants.allStatuses;
  };

  onOpen($mdMenu, event) {
    $mdMenu.open(event);
  }

  onChangeStatus(selectedStatus) {
    if (this.status !== selectedStatus) {
      this.onChange({status: selectedStatus});
    }
  }

}

angular
  .module('bringoz.admin.self-pickups')
  .component('selfPickupStatusButton', {
    bindings: {
      status: '<',
      isOutline: '<?',
      onChange: '&'
    },
    template: require('./self-pickup-status-button.html').default,
    controller: selfPickupStatusButtonCtrl
  });
